module.exports = __webpack_public_path__ + "static/media/27.bbb2f5a3.png";